import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-overview-new',
  templateUrl: './overview-new.component.html',
  styleUrls: ['./overview-new.component.scss']
})
export class LearnOverviewNewComponent implements OnInit {
    isBackdropVisible = false;
    isModalOpen = false;
    isNoticiasModalOpen = false;
    currentCarouselIndex = 0;
    currentSliderIndex = 0;
    cardsToShow = 4;
  
    user = { name: 'Rafael Rivas', level: 7 };
  
    slides = [
      {
        provider: 'Griky',
        title: 'Giving positive and constructive feedback',
        description: 'To train for: Giving positive feedback, to motivate the other person and improve their self-confidence...',
        duration: '12h 20min',
        image: 'https://via.placeholder.com/1200x400?text=Feedback+Course'
      },
      {
        provider: 'Griky',
        title: 'Another Course Title',
        description: 'Another description for a different course...',
        duration: '10h 30min',
        image: 'https://via.placeholder.com/1200x400?text=Another+Course'
      }
    ];
  
    cards = [
      {
        image: 'https://via.placeholder.com/300x200?text=Card+1',
        title: 'How to prepare a business meeting that...',
        category: 'Ruta de aprendizaje',
        rating: '4.8',
        progress: 66,
        duration: '3h 20min'
      },
      {
        image: 'https://via.placeholder.com/300x200?text=Card+2',
        title: 'How to prepare a business meeting that...',
        category: 'Ruta de aprendizaje',
        rating: '4.8',
        progress: 50,
        duration: '3h 20min'
      },
      {
        image: 'https://via.placeholder.com/300x200?text=Card+3',
        title: 'How to prepare a business meeting that...',
        category: 'Ruta de aprendizaje',
        rating: '4.8',
        progress: 75,
        duration: '3h 20min'
      },
      {
        image: 'https://via.placeholder.com/300x200?text=Card+4',
        title: 'How to prepare a business meeting that...',
        category: 'Ruta de aprendizaje',
        rating: '4.8',
        progress: 90,
        duration: '3h 20min'
      },
      {
        image: 'https://via.placeholder.com/300x200?text=Card+5',
        title: 'How to prepare a business meeting that...',
        category: 'Ruta de aprendizaje',
        rating: '4.8',
        progress: 30,
        duration: '3h 20min'
      }
    ];
  
    ngOnInit() {}
  
    openModal() {
      this.isModalOpen = true;
      this.isBackdropVisible = true;
    }
  
    openNoticiasModal() {
      this.isNoticiasModalOpen = true;
      this.isBackdropVisible = true;
    }
  
    closeModal() {
      this.isModalOpen = false;
      this.isBackdropVisible = false;
    }
  
    closeNoticiasModal() {
      this.isNoticiasModalOpen = false;
      this.isBackdropVisible = false;
    }
  
    previewPDF(filePath: string) {
      console.log('Previewing PDF:', filePath);
    }
  
    downloadPDF(filePath: string) {
      console.log('Downloading PDF:', filePath);
    }
  
    prevSlide() {
      this.currentCarouselIndex = (this.currentCarouselIndex > 0) ? this.currentCarouselIndex - 1 : this.slides.length - 1;
    }
  
    nextSlide() {
      this.currentCarouselIndex = (this.currentCarouselIndex < this.slides.length - 1) ? this.currentCarouselIndex + 1 : 0;
    }
  
    goToSlide(index: number) {
      this.currentCarouselIndex = index;
    }
  
    prevSlider() {
      this.currentSliderIndex = (this.currentSliderIndex > 0) ? this.currentSliderIndex - 1 : Math.max(0, this.cards.length - this.cardsToShow);
    }
  
    nextSlider() {
      this.currentSliderIndex = (this.currentSliderIndex < this.cards.length - this.cardsToShow) ? this.currentSliderIndex + 1 : 0;
    }
}